import {defineMessages} from 'react-intl';
import type {OpenapiPostV1CryptoInternalRelayQuoteInputInputCurrencyEnum} from '@stripe-internal/data-v1/schema/types';
import type {MessageDescriptor} from 'react-intl';

export type TokenInfo = {
  token: OpenapiPostV1CryptoInternalRelayQuoteInputInputCurrencyEnum;
  displayName: string;
  processingTimeMessage: MessageDescriptor;
};

const messages = defineMessages({
  btcProcessingTime: {
    id: 'crypto.payins.v2.token_select.btc_processing_time',
    description: 'Processing time for BTC transactions',
    defaultMessage: 'Process in 15–30 mins',
  },
  ethProcessingTime: {
    id: 'crypto.payins.v2.token_select.eth_processing_time',
    description: 'Processing time for ETH transactions',
    defaultMessage: 'Process in 1–5 mins',
  },
  fastProcessingTime: {
    id: 'crypto.payins.v2.token_select.fast_processing_time',
    description: 'Processing time for fast transactions (SOL, USDC)',
    defaultMessage: 'Process in <30 secs',
  },
});

export const TOKEN_INFO_MAP: Record<
  OpenapiPostV1CryptoInternalRelayQuoteInputInputCurrencyEnum,
  Omit<TokenInfo, 'token'>
> = {
  btc: {
    displayName: 'Bitcoin',
    processingTimeMessage: messages.btcProcessingTime,
  },
  eth: {
    displayName: 'Ethereum',
    processingTimeMessage: messages.ethProcessingTime,
  },
  sol: {
    displayName: 'Solana',
    processingTimeMessage: messages.fastProcessingTime,
  },
  usdc: {
    displayName: 'USD Coin',
    processingTimeMessage: messages.fastProcessingTime,
  },
};
